import { List, ListSubheader, Divider } from '@mui/material';
import NotificationItem from '../NotificationItem';
import ScrollToBottom from 'src/component-project/ScrollToBottom';
import { t } from 'i18next';

const ListNotiWarning = ({
    value,
    totalNotiWarning,
    listWarning,
    handleClose,
    loading,
    handleScrollToBottom
}) => {
    
    return (
        <>
            {value === 'warning' && totalNotiWarning > 0 ? (
                <List
                    disablePadding
                    subheader={
                        <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                            {t('not_read')}
                        </ListSubheader>
                    }
                >
                    {listWarning.map((notification, index) =>
                        notification.status_notify === '1' ? (
                            <NotificationItem key={index} notification={notification} handleClose={handleClose} />
                        ) : (
                            ''
                        )
                    )}
                    {/* <ScrollToBottom onScrollToBottom={handleScrollToBottom} loading={loading} /> */}
                </List>
            ) : (
                ''
            )}
            <Divider sx={{ borderStyle: 'dashed' }} />

            {value === 'warning' && (
                <List
                    disablePadding
                    subheader={
                        <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                            {t('reader')}
                        </ListSubheader>
                    }
                >
                    {listWarning.map((notification, index) =>
                        notification.status_notify === '0' ? (
                            <NotificationItem key={index} notification={notification} handleClose={handleClose} />
                        ) : (
                            ''
                        )
                    )}
                    <ScrollToBottom onScrollToBottom={handleScrollToBottom} loading={loading} />
                </List>
            )}
        </>
    );
};

export default ListNotiWarning;
